export const EXCMAGREEMENT_CREATE_RESET = 'EXCMAGREEMENT_CREATE_RESET'
export const EXCMAGREEMENT_CREATE_SET_CREATED = 'EXCMAGREEMENT_CREATE_SET_CREATED'
export const EXCMAGREEMENT_CREATE_SET_ERROR = 'EXCMAGREEMENT_CREATE_SET_ERROR'
export const EXCMAGREEMENT_CREATE_SET_VIOLATIONS = 'EXCMAGREEMENT_CREATE_SET_VIOLATIONS'
export const EXCMAGREEMENT_CREATE_TOGGLE_LOADING = 'EXCMAGREEMENT_CREATE_TOGGLE_LOADING'
